import { TimelogTypes } from 'constants/enums';

export const filterTypesOptions = (timeLogTypes: ILogType[], isCCMOnlyPatient: boolean) => {
  const RPMTaskTypes = [TimelogTypes.RPM, TimelogTypes.RPM_NURSE] as string[];
  return timeLogTypes.filter((type) => {
    return !(isCCMOnlyPatient && RPMTaskTypes.includes(type.timeLogTypeId));
  });
};

export const UNDEFINED_KEY = 'undefinedKey';
